import {omit} from 'lodash';

import {CourseForm} from 'portfolio/components/bulk-entry/course-form-wrapper';
import {
  RECEIVE_OCR_COURSES,
  SET_IS_BACK,
  SET_IS_NEXT,
  SET_COURSE_IDS_TO_DELETE,
  SET_SHOW_SURVEY,
} from './actions';

export interface ReportCardReducer {
  courses: CourseForm[];
  isBack: boolean;
  isNext: boolean;
  courseIdsToDelete: string[];
  showSurvey: boolean;
}

const reportCardReducer = (
  state: ReportCardReducer = {
    courses: [],
    isBack: false,
    isNext: false,
    courseIdsToDelete: [],
    showSurvey: false,
  },
  action: {
    type:
      | typeof RECEIVE_OCR_COURSES
      | typeof SET_IS_BACK
      | typeof SET_IS_NEXT
      | typeof SET_COURSE_IDS_TO_DELETE
      | typeof SET_SHOW_SURVEY;
  } & Partial<ReportCardReducer>
) => {
  switch (action.type) {
    case RECEIVE_OCR_COURSES:
    case SET_IS_NEXT:
    case SET_IS_BACK:
    case SET_COURSE_IDS_TO_DELETE:
    case SET_SHOW_SURVEY:
      return {...state, ...omit(action, 'type')};
    default:
      return state;
  }
};

export default reportCardReducer;
